import React, { useState, useRef, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { getListTicket, updateDataSearch } from "../../actions/Ticket";
import { AddTicketDeskTopBtn } from "./AddTicketDesktop";
// import { AddTicketDeskTopBtn } from "./AddTicketDesktop.js";

export const TableTicket = ({ dataTicket, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchTicket);
  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    onSearch();
  };
  return (
    <>
      <div className="card border-light mb-1  card-v2">
        <div className="card-body card-body-v2  mb-1">
          <AddTicketDeskTopBtn onSearch={onSearch} />
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh1 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers" style={{ top: "4rem" }}>
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {dataTicket.Totals} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-30 flex-basis-30-sm">
                    <p className="text-left">Tiêu đề</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-center">Chức năng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Ngày tạo</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Người tiếp nhận</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Deadline</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header text-center">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header text-center">Thao tác</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {typeof dataTicket.TicketResults != "undefined" &&
                    dataTicket.TicketResults.length > 0 && (
                      <ContentTable dataTicket={dataTicket} />
                    )}
                  {typeof dataTicket.TicketResults === "undefined" ||
                    (dataTicket.TicketResults.length === 0 && (
                      <div>Không có dữ liệu</div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card border-light mb-1  card-v2">
        <div className="card-body card-body-v2  mb-1">
          <div className="card-body card-body-v2">
            <div className="row">
              <div className="col-sm-12  col-md-6">
                <span className="color7">
                  Hiển thị {dataTicket.Totals == 0 ? "0" : "1"} -{" "}
                  {dataSearch.pageSize}/ Tổng số {dataTicket.Totals}
                </span>
              </div>
              <div className="col-sm-12  col-md-6">
                <div
                  className={
                    "paniation-new paniation-new1 d-flex justify-content-center " +
                    (dataTicket.Totals === 0 ? "hidden" : "")
                  }
                  style={{ float: "right" }}
                >
                  <nav aria-label="Page navigation">
                    <Pagination
                      activePage={dataSearch.pageIndex}
                      itemsCountPerPage={dataSearch.pageSize}
                      totalItemsCount={dataTicket.Totals}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      itemClass="page-item border-none"
                      linkClass="page-link border-none"
                      activeClass="active"
                    />
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
